import {
  MDBBtn,
  MDBCheckbox,
  MDBChip,
  MDBCol,
  MDBModalFooter,
  MDBRadio,
  MDBRow,
  MDBSpinner,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import { useRef, useEffect } from "react";
import { formattedNumber } from "./AddRemoveNumbers";
import {
  portingSteps,
  portingStepsForm,
} from "../../../apiclients/streamsapi_bridge";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";
import TabIDConstant from "../../../apiclients/TabIDConstant";

function SignLOA({
  watch,
  handleNext,
  currentStep,
  handleBack,
  telePhoneList,
  setValue,
  portingType,
  setflowStep,
  nextPageclick,
  flowStep,
  handleSubmit,
  uploadedFiles,
  uploadedOldFiles,
  formState,
  setorderID,
  handleSaveDraft,
  orderID,
  setIsloading,
  skipFlag,
}) {
  // const [isloading, setIsloading] = useState(false);
  const getCurrentDate = () => {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };

  const handleForNext = async (data) => {
    let update = {
      reqid: parseInt(portingType) === 3 ? 96 : 91,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      port_type: parseInt(portingType),
      flow_step: parseInt(flowStep),
      sign_loa: {
        consent_flag: data.sign_loa.consent_flag,
      },
    };

    console.log("update :::::::::: " + JSON.stringify(update));

    let saverep = await portingSteps(update);
    console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log("response of next:::" + JSON.stringify(saverepeMsg));
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      setflowStep(parseInt(flowStep) + 1);
      nextPageclick();
    } else {
    }
  };

  const { dirtyFields, isDirty, errors } = formState;

  const checkboxRef = useRef(null);
  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.focus();
    }
  }, []);

  // MDB Modal adds a window-level keydown listener that intercepts ALL Tab presses
  // and calls preventDefault(), preventing natural focus movement (including checkboxes).
  // stopPropagation() stops bubbling to the window listener so the browser handles
  // natural Tab focus movement within the form.
  const handleTabKeyNavigation = (e) => {
    if (e.key !== 'Tab') return;
    e.stopPropagation();
  };

  const streamsProductName = getStreamsProductName();

  const restrictedFields = new Set();

  if (portingType === 3) {
    restrictedFields.add("notifs_comments");
    restrictedFields.add("checklist");
    restrictedFields.add("assign");

    if (skipFlag === 3) {
      restrictedFields.add("acc_info");
      restrictedFields.add("service_addr");
    } else if (skipFlag === 2) {
      restrictedFields.add("service_addr");
    } else if (skipFlag === 1) {
      restrictedFields.add("acc_info");
    }
  }

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      formData.append("reqid", portingType === 1 ? 91 : 96);
      formData.append("confirm_flag", true);
      formData.append("port_type", parseInt(portingType));
      formData.append("flow_step", parseInt(flowStep));
      formData.append("orderid", parseInt(orderID));

      formData.append("status", portingType === 3 ? 5 : 1);
      if (portingType === 3 && skipFlag !== 0) {
        formData.append("skipFlag", parseInt(skipFlag));
      }
      for (const field of Object.keys(dirtyFields)) {
        let modifiedData = {};
        if (portingType === 3 && restrictedFields.has(field)) {
          continue; // skip this field
        }
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            for (const subfield of Object.keys(dirtyFields[field])) {
              if (data[field].hasOwnProperty(subfield)) {
                modifiedData[subfield] = data[field][subfield];
              }
            }
            if (field === "notifs_comments") {
              modifiedData.send_email_to_admin =
                data[field]["send_email_to_admin"];
            }
            if (field !== "checklist") {
              formData.append(field, JSON.stringify(modifiedData));
            }
          } else {
            modifiedData = [...data[field]];
            formData.append(field, JSON.stringify(modifiedData));
          }
        }
      }
      if (portingType !== 3) {
        formData.append("checklist", JSON.stringify(data.checklist));
      }
      uploadedFiles.forEach((file) => {
        formData.append("upload_latest_bill", file, file.name);
      });
      //formData.append("upload_latest_bill", uploadedFiles);
      //  formData.append("sign_loa", uploadFile);

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      setIsloading(true);

      let saverep = await portingStepsForm(formData, TabIDConstant.TN_TFN_PORT_BTN_SUBLINK);
      setIsloading(false);
      console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log("response of next:::" + JSON.stringify(saverepeMsg));
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setorderID(saverepeMsg.order_id);

        setflowStep(parseInt(flowStep) + 1);
        nextPageclick();
      } else {
      }
    } catch (error) {
      console.log(`Error: ${error}`);
    }
  };

  // const handleSaveDraft = async (data) => {
  //   if (dirtyFields.length > 0) {
  //     const formData = new FormData();

  //     formData.append(
  //       "siteid",
  //       JSON.parse(sessionStorage.getItem("admin_session")).siteid
  //     );
  //     formData.append("reqid", parseInt(portingType) === 1 ? 91 : 96);
  //     formData.append("port_type", parseInt(portingType));
  //     formData.append("flow_step", parseInt(flowStep));
  //     formData.append("save_as_draft", 1);
  //     for (const field of Object.keys(dirtyFields)) {
  //       let modifiedData = {};
  //       if (dirtyFields[field] && data.hasOwnProperty(field)) {
  //         if (typeof data[field] === "object" && !Array.isArray(data[field])) {
  //           for (const subfield of Object.keys(dirtyFields[field])) {
  //             if (data[field].hasOwnProperty(subfield)) {
  //               modifiedData[subfield] = data[field][subfield];
  //             }
  //           }
  //           // if (field === "acc_info") {
  //           //   modifiedData.porting_num_type = data[field]["porting_num_type"];
  //           // }
  //           if (field === "notifs_comments") {
  //             modifiedData.send_email_to_admin =
  //               data[field]["send_email_to_admin"];
  //           }

  //           formData.append(field, JSON.stringify(modifiedData));
  //         } else {
  //           modifiedData = [...data[field]];
  //           formData.append(field, JSON.stringify(modifiedData));
  //         }
  //       }
  //     }
  //     formData.append("checklist", JSON.stringify(data.checklist));
  //     if (uploadedFiles && uploadedFiles.length > 0) {
  //       formData.append("upload_latest_bill", uploadedFiles);
  //     }
  //     if (uploadedOldFiles && uploadedOldFiles.length > 0) {
  //       formData.append("old_cob_files", uploadedOldFiles);
  //     }
  //     let saverep = await portingStepsForm(formData);
  //     console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
  //     let saverepeMsg = await saverep.json();
  //     console.log("response of next:::" + JSON.stringify(saverepeMsg));

  //     if (saverepeMsg.status && saverepeMsg.status == "success") {
  //       document.getElementById("draftsuccess").innerHTML = saverepeMsg.message;
  //     } else {
  //       if (saverepeMsg.message?.errors) {
  //         // saverepeMsg.message.errors.forEach((err) => {
  //         //   setError(err.param_name, {
  //         //     type: "server",
  //         //     message: err.message,
  //         //   });
  //         //   const fieldElement = document.querySelector(
  //         //     `input[name="${err.param_name}"]`
  //         //   );
  //         //   if (fieldElement) {
  //         //     fieldElement.focus();
  //         //     fieldElement.scrollIntoView({ behavior: "smooth" });
  //         //   }
  //         // });
  //       } else {
  //       }
  //     }
  //   }
  // };

  return (
    <>
      <div className="container  overflowAuto submit-details-container h-93" onKeyDown={handleTabKeyNavigation}>
        <div className="pb-3 mb-3">
          <h5>Letter of Limited Agency</h5>
          <div>
            <p className="mt-2">
              The undersigned (“Customer”) hereby authorizes PanTerra
              Networks.com, Inc. (“{streamsProductName}”) to act as an Agent of the Customer
              for the limited purpose of and with authority to:
            </p>
            <p className="mt-2">
              (1) Order changes and/or to{" "}
              {portingType === 1 ? "trasfer" : "validate"} the Customer’s
              communications services (including LNP requests) to any local
              exchange carrier; and
            </p>
            <p className="mt-2">
              (2) Obtain information regarding the Customer’s communications
              services, including without limitation: service configuration and
              location information, Customer Proprietary Network Information
              (CPNI)/Customer Service Record (CSR), billing status and all
              pending service order activity.
            </p>
            <p className="mt-2">
              Agent shall have authority to execute such documents and
              instruments as are necessary or appropriate to affect the powers
              granted herein. This appointment includes the right of Agent to
              delegate to its selected local exchange carrier the authority
              granted herein.
            </p>
            <p className="mt-2">
              The Customer releases you from any and all liability for complying
              with instructions and requests of Agent with respect to the grant
              of agency set forth above. The Customer further releases Agent
              from liability for any charges of the Customer with respect to
              Customer’s charges for communications services, all of which the
              Customer covenants will be paid in full.
            </p>
            <p className="mt-2">
              The Customer understands that only one telecommunications carrier
              may be designated as the Customer’s interstate or inter-LATA
              preferred inter-exchange carrier for any one telephone number. The
              Customer may consult with the carrier as to whether a fee will
              apply to the change in the Customer’s preferred carrier. To the
              extent that a jurisdiction allows the selection of additional
              preferred carriers (e.g., local exchange, intra-LATA/intrastate
              toll, inter-LATA/interstate toll, or international inter-exchange)
              this Letter of Agency must contain the Customer’s separate
              statements regarding those individual choices, although a separate
              Letter of Agency for each choice is not necessary.
            </p>
            <p className="mt-2">
              This Limited Agency Authorization shall become effective from the
              date written below and shall remain in full force and in effect
              for thirty (30) days or until terminated by Customer or Agent upon
              fifteen (15) days prior to written notice. This letter does not
              stop the customer from acting on their own behalf.
            </p>
          </div>
          <p className="my-2">
            <MDBRadio
              name="flexRadioDefault"
              id="flexRadioDefault1"
              label="Business"
              checked
            />
          </p>

          <MDBRow className="mt-3">

            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Date:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {getCurrentDate()}
                </div>
              </div>
            </MDBCol>
            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Print Name:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.first_name") +
                    " " +
                    watch("acc_info.last_name")}
                </div>
              </div>
            </MDBCol>
            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Signature:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.first_name") +
                    " " +
                    watch("acc_info.last_name")}
                </div>
              </div>
            </MDBCol>

            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Company Name:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.company_name")}
                </div>
              </div>
            </MDBCol>

            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Current Carrier Name:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.curr_carrier_name")}
                </div>
              </div>
            </MDBCol>

            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Billing Telephone Number:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.bill_tele_num")
                    ? formattedNumber(watch("acc_info.bill_tele_num") + "")
                    : ""}
                </div>
              </div>
            </MDBCol>
            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Account Number:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.acc_num")}
                </div>
              </div>
            </MDBCol>
            {portingType === 1 && (
              <MDBCol sm={12} md={6} lg={6} xl={6}>
                <div className="d-flex align-items-end justify-content-between loa-feild-container">
                  <div className="tel-numbers">Caller ID Name:</div>
                  <div className="w-60 border-bottom ps-2 loa-feild">
                    {/* {watch("acc_info.bill_tele_num")
                    ? formattedNumber(watch("acc_info.bill_tele_num") + "")
                    : ""} */}
                    {watch("acc_info.caller_id_name") ?? ""}
                  </div>
                </div>
              </MDBCol>
            )}
            {portingType === 1 && (
              <MDBCol sm={12} md={6} lg={6} xl={6}>
                <div className="d-flex align-items-end justify-content-between loa-feild-container">
                  <div className="tel-numbers">Floor Number:</div>
                  <div className="w-60 border-bottom ps-2 loa-feild">
                    {watch("service_addr.floor_num") ?? ""}
                  </div>
                </div>
              </MDBCol>
            )}
            {portingType === 1 && (
              <MDBCol sm={12} md={6} lg={6} xl={6}>
                <div className="d-flex align-items-end justify-content-between loa-feild-container">
                  <div className="tel-numbers">Suite:</div>
                  <div className="w-60 border-bottom ps-2" style={{ lineHeight: '1.2' }}>
                    {/* {watch("acc_info.bill_tele_num")
                    ? formattedNumber(watch("acc_info.bill_tele_num") + "")
                    : ""} */}
                    {watch("service_addr.suite") ?? ""}
                  </div>
                </div>
              </MDBCol>
            )}

            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Service Street Address:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("service_addr.floor_num") +
                    " " +
                    watch("service_addr.street_num") +
                    " " +
                    watch("service_addr.street_name")}
                </div>
              </div>
            </MDBCol>

            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">City:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("service_addr.city")}
                </div>
              </div>

            </MDBCol>
            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">State:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("service_addr.state")}
                </div>
              </div>
            </MDBCol>
            <MDBCol sm={12} md={6} lg={6} xl={6}>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Zip:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("service_addr.zip")}
                </div>
              </div>
            </MDBCol>
            {portingType !== 3 && (
              <MDBCol sm={12} md={6} lg={6} xl={6}>
                <div className="d-flex align-items-end justify-content-between loa-feild-container">
                  <div className="tel-numbers">Desired Due Date:</div>
                  <div className="w-60 border-bottom ps-2 loa-feild">
                    {" "}
                    {watch("enter_num.ddd")}{" "}
                  </div>
                </div>
              </MDBCol>
            )}
            {portingType !== 3 && (
              <MDBCol sm={12} md={6} lg={6} xl={6}>
                <div className="d-flex align-items-end justify-content-between loa-feild-container">
                  <div className="tel-numbers">Account PIN:</div>
                  <div className="w-60 border-bottom ps-2 loa-feild">
                    {watch("acc_info.acc_pin")}{" "}
                  </div>
                </div>
              </MDBCol>
            )}

          </MDBRow>






          <MDBRow className="mt-3">
            <MDBCol size={6} className="mob-w-100 mb-3">
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Date:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {getCurrentDate()}
                </div>
              </div> */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Signature:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.first_name") +
                    " " +
                    watch("acc_info.last_name")}
                </div>
              </div> */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Title:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.title")}
                </div>
              </div> */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Current Carrier Name:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.curr_carrier_name")}
                </div>
              </div> */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Account Number:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.acc_num")}
                </div>
              </div> */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Name Listed on Account:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.name_listed_on_acc")}
                </div>
              </div> */}
              {/* {portingType === 1 && (
                <div className="d-flex align-items-end justify-content-between loa-feild-container">
                  <div className="tel-numbers">Floor Number:</div>
                  <div className="w-60 border-bottom ps-2 loa-feild">
                    {watch("service_addr.floor_num") ?? ""}
                  </div>
                </div>
              )} */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Service Street Address:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("service_addr.floor_num") +
                    " " +
                    watch("service_addr.street_num") +
                    " " +
                    watch("service_addr.street_name")}
                </div>
              </div> */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">State:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("service_addr.state")}
                </div>
              </div> */}
            </MDBCol>

            {/* ----------------------------------------------&&------------------------------------------------------ */}

            <MDBCol size={6} className="mob-w-100 mb-3">
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Print Name:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.first_name") +
                    " " +
                    watch("acc_info.last_name")}
                </div>
              </div> */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Company Name:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.company_name")}
                </div>
              </div> */}
              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Billing Telephone Number:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("acc_info.bill_tele_num")
                    ? formattedNumber(watch("acc_info.bill_tele_num") + "")
                    : ""}
                </div>
              </div> */}

              {/* <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">City:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("service_addr.city")}
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between loa-feild-container">
                <div className="tel-numbers">Zip:</div>
                <div className="w-60 border-bottom ps-2 loa-feild">
                  {watch("service_addr.zip")}
                </div>
              </div> */}
              {/* {portingType !== 3 && (
                <>
                  <div className="d-flex align-items-end justify-content-between loa-feild-container">
                    <div className="tel-numbers">Desired Due Date:</div>
                    <div className="w-60 border-bottom ps-2 loa-feild">
                      {" "}
                      {watch("enter_num.ddd")}{" "}
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between loa-feild-container">
                    <div className="tel-numbers">Account PIN:</div>
                    <div className="w-60 border-bottom ps-2 loa-feild">
                      {watch("acc_info.acc_pin")}{" "}
                    </div>
                  </div>
                </>
              )} */}
            </MDBCol>
          </MDBRow>
          <div>
            <p className="fw-bold mt-2">
              Email all pages including a copy of the administrative pages
              (containing account name, authorized contact name, service
              address, billing number, etc.) of your most recent phone bill to:
              carriernotifications@panterranetworks.com
            </p>
            <h6 className="mt-2">
              Phone Numbers to {portingType === 1 ? "Transfer" : "Validate"}:
            </h6>
            <div className="">
              {/* <MDBTable bordered>
                <MDBTableHead>
                  <tr>
                    <th>Telephone Number</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {telePhoneList &&
                    telePhoneList.length > 0 &&
                    telePhoneList.map((telephone) => (
                      <tr>
                        <td scope="row">{formattedNumber(telephone + "")}</td>
                      </tr>
                    ))}
                </MDBTableBody>
              </MDBTable> */}

              <div className="d-flex flex-wrap gap-2 p-2 border border-2  rounded-4 listOfFiles-copy">
                {telePhoneList &&
                  telePhoneList.length > 0 &&
                  telePhoneList.map((telephone) => (
                    <MDBChip scope="row">
                      {formattedNumber(telephone + "")}
                    </MDBChip>
                  ))}
              </div>
            </div>
          </div>

          <div className="bg-secondary bg-opacity-25 d-block p-4 mt-3">
            <h5 className="d-block text-center">
              Federal Electronic Disclosure and Consent
            </h5>
            <p className="mt-3">
              PanTerra Networks.com permits you to fill out and sign certain
              forms using this web site. This Federal E-Sign Disclosure and
              Consent describes PanTerra Networks.com' process so that you can
              decide whether you wish to continue with your request through our
              web site. Please read this page carefully and print a copy of this
              page for your records
            </p>
            <strong className="mt-3 d-block">
              Electronic Signature and Electronic Delivery of Disclosures and
              Notices
            </strong>
            <p className="mt-3">
              By clicking in the box marked "I agree" at the bottom of this
              page, you consent to use electronic communications, electronic
              records, and electronic signatures rather than paper documents for
              the forms provided on this web site. Those forms include
            </p>

            <ol className="mt-3">
              <li>
                The Letter of Authorization permitting PanTerra Networks.com to
                Port your local or toll-free number(s) AND/OR Validate your
                number
                {portingType === 3
                  ? "(s) for use of Outbound Caller-ID. Please note: Validation requests DO NOT Port numbers"
                  : ""}
              </li>
              <li>
                All service and transaction updates regarding the status of
                Porting{" "}
                {portingType === 1
                  ? "process for your local number"
                  : "AND/OR Validation of your number(s)"}
                ;
              </li>
              <li>Responses to communications from you;</li>
              <li>Other documents relating to the porting process;</li>
              <li>
                All changes and updates to these disclosures, notices, and
                documents.
              </li>
            </ol>
            <p className="mt-3">
              You understand that your electronic signature is legally binding,
              just as if you had signed a paper document. Your consent to use
              electronic signatures and documents applies only to materials
              related to your request for PanTerra Networks.com to port your
              local or toll-free number.
            </p>
            <strong className="d-block mt-3">
              Paper Signature and Paper Delivery of Disclosures and Notices
            </strong>
            <p className="mt-3">
              If you prefer to use paper signatures, you may instead print a
              copy of the Letter of Authorization on the next page, fill it out,
              and return it to us by email. You understand that PanTerra
              Networks.com will not begin to process your request until it
              receives the Letter of Authorization.
            </p>
            <p className="mt-3">
              You have the right to receive a paper copy of the disclosures,
              notices, terms and conditions, and other communications described
              above. There is no cost to receive paper copies of any electronic
              records. If you wish to receive a paper copy, please send a
              request with your name, mailing address, daytime telephone number,
              and the document you wish to receive to one of the following
              [PanTerra Networks.com to provide contact information for E-Sign
              Act communications]:
            </p>
            <p className="mt-3">
              <strong>Email:</strong> carriernotifications@panterranetworks.com
            </p>
            <p>
              <strong>Dial Toll-free number:</strong> (800) 619-3688 and follow
              the prompts to reach LNP admin
            </p>
            {portingType === 3 && (
              <>
                <p>
                  <strong>Mail:</strong> Panterra Networks
                </p>
                <p>1737 N. 1st St., Suite 230, San Jose, CA 95112 US</p>
              </>
            )}

            <p className="mt-3">
              <strong>System Requirements:</strong>
            </p>
            <p className="mt-3">
              In order to use electronic signatures and to receive electronic
              communications, you must have a personal computer or other device
              that can connect to the Internet; an e-mail address; a web
              browser; software that enables you to receive and view Portable
              Document Format (PDF) files, such as Adobe Acrobat Reader
              (available for a free download at http://get.adobe.com/reader/)
            </p>
            <p className="mt-3">
              <strong>
                Withdrawal of Electronic Acceptance of Disclosures and Notices
              </strong>
            </p>
            <p className="mt-3">
              You may withdraw your consent to receive electronic communications
              at any time. If you wish to do so, please notify us at the
              addresses above and provide your name, mailing address, daytime
              telephone number, and a description of the type of transaction
              from which you are withdrawing your consent.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-light shadow-3 rounded-4 border-2 border p-2 my-3  container ">
        <div className="d-flex">
          {/* <MDBCheckbox
              checked={watch("sign_loa.consent_flag")}
              onChange={(e) =>
                setValue("sign_loa.consent_flag", e.target.checked, {
                  shouldDirty: true,
                })
              }
            /> */}

          <div className="d-flex align-items-center mb-2">
            <MDBCheckbox
              id="consentCheckbox"
              name="consentCheckbox"
              inputRef={checkboxRef}
              label={
                <>
                  I Agree. I consent to use electronic records and signature
                  in connection with my request to{" "}
                  {portingType === 1 ? "transfer" : "validate"} my telephone
                  number(s) to PanTerra Networks.com LLC.
                </>
              }
              checked={watch("sign_loa.consent_flag") ?? false}
              onChange={(e) =>
                setValue("sign_loa.consent_flag", e.target.checked, {
                  shouldDirty: true,
                })
              }
            />
          </div>

          {/* <div className="d-flex align-items-center mb-2">
              <label
                className={`big-checkbox d-flex align-items-center ${watch("sign_loa.consent_flag") ? "checked" : ""
                  }`}

                style={{ top: watch("sign_loa.consent_flag") ? "4px" : "4px" }}
              >
                <input
                  type="checkbox"
                  id="consentCheckbox"
                  name="consentCheckbox"
                  checked={watch("sign_loa.consent_flag") ?? false}
                  onChange={(e) =>
                    setValue("sign_loa.consent_flag", e.target.checked, {
                      shouldDirty: true,
                    })
                  }
                />
                <span className="box me-2">
                  <svg
                    className="checkmark"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                      fill="#FFFFFF"
                    />
                  </svg>
                </span> I Agree. I consent to
                use electronic records and signature in correction with my
                request to {portingType === 1 ? "transfer" : "validate"} my
                telephone number(s) to PanTerra Networks.com LLC.
              </label>
            </div> */}
        </div>
        <div className="text-danger small">
          Note: Please select the checkbox to give your consent to use
          electronic records and signature for the process of{" "}
          {portingType === 1 ? "porting" : "validation"}. Selecting the
          checkbox will enable Submit button to proceed further.
        </div>
      </div>

      <MDBModalFooter className="d-flex justify-content-between">
        {watch("sign_loa.consent_flag") && (
          <>
            <MDBBtn
              color="secondary"
              className="text-normal-case"
              onClick={(e) => {
                e.preventDefault();
                handleSubmit(handleSaveDraft)();
              }}
            >
              Save to Draft
            </MDBBtn>
            <span id="draftsuccess"></span>
            <div className="text-end">
              {/* <MDBBtn
                color="secondary"
                className="me-2"
                onClick={handleBack}
                disabled={currentStep === 0}
              >
                Back
              </MDBBtn> */}
              {watch("sign_loa.consent_flag") && (
                <MDBBtn
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(onSubmit)();
                  }}
                >
                  submit
                </MDBBtn>
              )}
            </div>
          </>
        )}
      </MDBModalFooter>
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
    </>
  );
}

export default SignLOA;
